import type { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import type { NotebookChemicalListResponse } from "../../data/models/schemas";

export * from "./libraryBase";

import {
    createReaction as baseCreateReaction,
    type ILibraryChemical,
    loadChemicals as baseLoadChemicals,
    updateReaction as baseUpdateReaction,
} from "./libraryBase";
import {
    toReactionCreateRequest,
    toReactionUpdateRequest,
} from "../../domain/reactions/reactionPersistencePayloads";

type CreateReactionActionArgs = NonNullable<
    Parameters<typeof baseCreateReaction.action>[0]
>;
type UpdateReactionActionArgs = NonNullable<
    Parameters<typeof baseUpdateReaction.action>[0]
>;

type LibraryChemicalListResponse = Omit<
    NotebookChemicalListResponse,
    "items"
> & {
    // GetChemicalsRoute always hydrates these fields from persisted notebook rows.
    // Keep the generated response shape while preserving the stronger library UI invariant.
    items?: ILibraryChemical[];
};

export const loadChemicals = {
    ...baseLoadChemicals,
    success: baseLoadChemicals.success as ActionCreatorWithPayload<
        LibraryChemicalListResponse,
        string
    >,
};

/**
 * Defensive action facades keep stale derived fields and copied relationship
 * identities out of every reaction persistence request, regardless of caller.
 */
export const createReaction = {
    ...baseCreateReaction,
    action: (args: CreateReactionActionArgs = {}) =>
        baseCreateReaction.action({
            ...args,
            body: args.body ? toReactionCreateRequest(args.body) : args.body,
        }),
};

export const updateReaction = {
    ...baseUpdateReaction,
    action: (args: UpdateReactionActionArgs = {}) =>
        baseUpdateReaction.action({
            ...args,
            body: args.body ? toReactionUpdateRequest(args.body) : args.body,
        }),
};
